export default {
    list: [{
        id: 1,
        name: 'components.gifts.giftPoints.title',
        icon: 'fal fa-hand-holding-box',
        route: {
            name: 'client.gift.points',
        },
    }, ]
}